import { Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { When } from 'react-if';

import * as S from './user-first-login-layout.styles';

import { ReactNode } from 'react';
import { Logo } from '../../../../components';

export interface UserFirstLoginLayoutProps {
  children: ReactNode;
}

const UserFirstLoginLayout: React.FC<UserFirstLoginLayoutProps> = (props) => {
  const { children } = props;

  const theme = useTheme();
  const isSmallOrLess = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <S.Container isSmall={isSmallOrLess}>
      <When condition={isSmallOrLess}>
        <div className="left-container">
          <div className="logo">
            <Logo />
          </div>

          <S.TextContainer>
            <Typography variant="h4" color="#fff">
              Welcome to POM Safe!
            </Typography>
            <Typography
              textAlign="center"
              color="#fff"
              variant="subtitle1"
              mt="24px"
            >
              Here you have access to all metrics and monitoring
              of your users and devices!
            </Typography>
          </S.TextContainer>
        </div>
      </When>
      <div className="right-container">{children}</div>
    </S.Container>
  );
};

export default UserFirstLoginLayout;
